import { render, staticRenderFns } from "./viewNewsletter.vue?vue&type=template&id=c829df02&"
import script from "./viewNewsletter.vue?vue&type=script&lang=js&"
export * from "./viewNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports